import { encodedStringParser, stringParser } from '../inboundParsers';
const ORDERED_MESSAGE_BOX_BEHAVIORS = ['replace', 'update_current_only', 'add'];
function messageBoxBehaviorParser(str) {
    return ORDERED_MESSAGE_BOX_BEHAVIORS[Number(str)];
}
export const MESSAGE_BOX_PAYLOAD_DEFINITION = {
    numTimesToFlatSplit: 6,
    definitionParts: [
        { name: 'legacyFlashMovieClipLabel', parser: stringParser },
        { name: 'rgbString', parser: stringParser },
        { name: 'messageBoxBehavior', parser: messageBoxBehaviorParser },
        { name: 'refreshPacket', parser: encodedStringParser },
        { name: 'title', parser: encodedStringParser },
        { name: 'html', parser: stringParser }
    ]
};
